import { render, staticRenderFns } from "./detailYuyue.vue?vue&type=template&id=4fcb3f69&scoped=true&"
import script from "./detailYuyue.vue?vue&type=script&lang=js&"
export * from "./detailYuyue.vue?vue&type=script&lang=js&"
import style0 from "./detailYuyue.vue?vue&type=style&index=0&id=4fcb3f69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb3f69",
  null
  
)

export default component.exports